<script>
  import { onMount, afterUpdate, createEventDispatcher } from 'svelte';
  import { slide } from 'svelte/transition';
  import * as animateScroll from 'svelte-scrollto';
  import { apiPost } from '../httpCommon';
  import Paper, { Title, Subtitle, Content as PaperContent } from '@smui/paper';
  import Card, { Content as CardContent } from '@smui/card';
  import Button, { Label, Group as ButtonGroup } from '@smui/button';
  import Select, { Option } from '@smui/select';
  import { Icon } from '@smui/icon-button';
  import Pay from './Pay.svelte';
  import SigninBox from '../components/SigninBox.svelte';
  import CustomerLocationBox from '../components/CustomerLocationBox.svelte';
  import Spinner from 'svelte-spinner';

  import axios from 'axios';

  import Dialog, { Content, Actions } from '@smui/dialog';

  let order_conf_dialog;

  import { auth, getAuthToken } from '../firebase.js';
  import { user } from '../store.js';
  import moment from 'moment';
  import GoogleLogin from './Auth/GoogleLogin.svelte';
  import { checkIfClosed } from '../utils';

  export let total = null;
  const emit = createEventDispatcher();
  let basket;
  let voucherCode;
  let voucherErr = false;
  export let voucherCodeUsed;
  export let fdEmailAddress;
  export let popup;

  export let orders;
  export let submitting = false;
  let signinBox;
  let locationBox;
  let locationComplete;
  let signinRedirect = false;
  export let venue;
  let paymentSuccessfull = false;

  $: venueId = venue && venue.id;

  $: {
    total = basket ? basket.total : 0;
    orders = basket && !basket.placed ? basket.orders : {};
  }

  $: voucherPlaceholder = voucherErr ? 'Sorry, code is invalid' : 'Voucher Code (optional)';

  export async function verify(verifyBasket) {
    try {
      submitting = true;
      basket = await apiPost('basket/verify', { basket: verifyBasket });
      setBasket(basket);
      emit('orderupdated', basket.orders);
    } finally {
      submitting = false;
    }
  }

  export async function addItem(popup_id, item_id) {
    try {
      submitting = true;

      if (basket && basket.placed) {
        clearBasket();
      }

      basket = await apiPost('basket/add-item', {
        basket,
        popup_id,
        item_id,
      });

      setBasket(basket);
      emit('orderupdated', basket.orders);
      paymentSuccessfull = false;
    } finally {
      submitting = false;
    }
  }

  export async function removeItem(popup_id, item_id, del) {
    try {
      submitting = true;
      del = del === undefined ? false : del;
      if (basket && basket.placed) {
        clearBasket();
      } else {
        basket = await apiPost('basket/remove-item', {
          basket,
          popup_id,
          item_id,
          delete: del,
        });
        setBasket(basket);
      }
      emit('orderupdated', basket.orders);
    } finally {
      submitting = false;
    }
  }

  export async function clearItem(popup_id, item_id) {
    try {
      submitting = true;
      if (basket && basket.placed) {
        clearBasket();
      } else {
        basket = await apiPost('basket/remove-item', {
          basket,
          popup_id,
          item_id,
          delete: true,
        });
        setBasket(basket);
      }
      emit('orderupdated', basket.orders);
    } finally {
      submitting = false;
    }
  }

  export function clearBasket() {
    basket = null;
    setBasket();
    emit('orderupdated', {});
  }

  export function itemCount(popup_id, item_id) {
    if (orders[popup_id]) {
      if (orders[popup_id][item_id]) {
        orders[popup_id][item_id].count;
      }
    }
    return 0;
  }

  function setBasket(basket) {
    if (basket) {
      localStorage.setItem('basket', JSON.stringify(basket));
    } else {
      localStorage.removeItem('basket');
    }
  }

  async function addVoucher(event) {
    event.preventDefault();

    if (voucherCode) {
      try {
        submitting = true;
        basket = await apiPost('basket/add-voucher', {
          basket,
          voucher_code: voucherCode,
        });
        setBasket(basket);
        emit('orderupdated', basket.orders);
        set_local_voucher_code(voucherCode);
      } catch (err) {
        voucherErr = true;
      } finally {
        submitting = false;
        voucherCode = null;
      }
    }
  }

  let order;
  let payment_error;

  async function onAuthorised(event) {
    submitting = true;

    const todaysEventClosed = checkIfClosed(orders);

    if (todaysEventClosed === true) {
      const firstItem = Object.assign([], orders).reverse()[0].id;
      let existing = localStorage.getItem('basket');
      existing = existing ? JSON.parse(existing) : {};
      delete existing['orders'][firstItem];
      setBasket(existing);
      basket = existing;
      location.reload();
    }

    const { nonce, cardId, saveCard } = event.detail;
    const params = { basket, nonce, card_id: cardId, save_card: saveCard };

    try {
      payment_error = null;
      basket = await apiPost('basket/payment', params);
      setBasket();
      emit('orderupdated', {});
      paymentSuccessfull = true;
      //set_local_voucher_code(voucherCode);
      clearBasket();
    } catch (err) {
      payment_error = err.message;
    } finally {
      submitting = false;
    }
  }

  function set_local_voucher_code() {
    console.log('basket voucher');
    if (!basket.voucher_code) return;
    var existing = localStorage.getItem('fd_opts');
    existing = existing ? JSON.parse(existing) : {};
    existing['vouchers'] = basket.voucher_code;
    localStorage.setItem('fd_opts', JSON.stringify(existing));
  }

  const watchuser = user.subscribe((userinfo) => {
    if (userinfo.loggedIn) {
      signinRedirect = false;
    }
  });

  function sort_by(a, b, attr) {
    if (!a[attr] || !b[attr]) {
      console.clear(` attr ${attr} not found in `, a, b);
    }
    if (a[attr] > b[attr]) {
      return 1;
    } else if (a[attr] < b[attr]) {
      return -1;
    }
    return 0;
  }

  let userDetails;
  function populateUserDetails() {
    const userLocalStorageDetails = localStorage.getItem('customerAddress');

    if (!userLocalStorageDetails) {
      return;
    }

    userDetails = JSON.parse(userLocalStorageDetails);
  }

  onMount(() => {
    if (auth.isSignInWithEmailLink(window.location.href)) {
      signinRedirect = true;
      signinBox.open();
    }

    try {
      const storedBasket = localStorage.getItem('basket');

      if (storedBasket) {
        verify(JSON.parse(storedBasket));
      }

      populateUserDetails();
    } catch (err) {
      console.clear('Error loading stored basket', err);
    }
  });

  function handleNoteChange(e) {
    e.preventDefault();
    const customerNotes = e.target.value;
    const customerNotesID = e.target.dataset.noteid;

    let existing = localStorage.getItem('basket');
    existing = existing ? JSON.parse(existing) : {};
    existing['orders'][customerNotesID]['customer_notes'] = customerNotes;
    setBasket(existing);
    basket = existing;
  }

  const DELIVERY_FEE = venue.delivery_fee_amount;
  function calculateSubtotal(prevSubTotal) {
    const updatedSubTotal = parseFloat(prevSubTotal) + DELIVERY_FEE;
    return updatedSubTotal.toFixed(2);
  }

  function calculateTotal(prevTotal) {
    const deliveryFeeTotal = Object.keys(basket.orders).length * DELIVERY_FEE;
    const updatedTotal = parseFloat(basket.subtotal) + deliveryFeeTotal - basket.discount_amount;

    return updatedTotal.toFixed(2);
  }

  let modalInnerSwitchPosition = true;

  function addCustomerDetails(e) {
    e.preventDefault();
    const form = new FormData(document.getElementById('address-form'));
    const email = form.get('email');
    const name = form.get('name');
    const address_one = form.get('address_one');
    const address_two = form.get('address_two');
    const city = form.get('city');
    const post_code = form.get('post_code');
    const phone = form.get('phone');

    const newUserAddress = {
      email,
      name,
      address_one,
      address_two,
      city,
      post_code,
      phone,
    };

    localStorage.setItem('customerAddress', JSON.stringify(newUserAddress));

    if (!basket.customer_address || !basket.fd_email_address || !basket.user_email_address) {
      let existing = localStorage.getItem('basket');
      existing = existing ? JSON.parse(existing) : {};
      existing['customer_address'] = newUserAddress;
      existing['fd_email_address'] = fdEmailAddress;
      existing['user_email_address'] = email;
      existing['popup_details'] = popup;
      existing['venue_details'] = venue;
      existing['actual_total'] = `${calculateTotal(basket.subtotal)}`;
      setBasket(existing);
      basket = existing;
    }

    modalInnerSwitchPosition = !modalInnerSwitchPosition;
  }

  let order_placed = false;
  let order_submitting = false;

  async function sendOrderEmail() {
    order_submitting = true;
    axios
      .post('https://food-disco-tmp-email-server.herokuapp.com/send-order-email', {
        // .post('http://localhost:7777/send-order-email', {
        basket,
      })
      .then(function (response) {
        if ((response.status = 200)) {
          order_placed = true;
          order_submitting = false;
          clearBasket();

          setTimeout(() => {
            location.reload();
          }, 5000);
        }
      })
      .catch(function (error) {
        order_placed = false;
        console.log(error);
      });
  }

  function closeModal() {
    order_conf_dialog.close();
    modalInnerSwitchPosition = !modalInnerSwitchPosition;
    location.reload();
  }

  import { apiGet } from '../httpCommon';

  async function openOrderModal() {
    let result = await apiGet(['popups', popup.id]);

    if (!result.popup_active) {
      alert('Sorry, this event has ended.  We hope to see you next time!');
      window.location.reload();
      return;
    }

    order_conf_dialog.open();
  }
</script>

<div class="basket" style="display: {popup.menu_ordering_active ? 'block' : 'none'}">
  <Dialog
    bind:this={order_conf_dialog}
    aria-labelledby="dialog-title"
    aria-describedby="dialog-content"
  >
    <div class="order-confirmation">
      <div class="order-confirmation__header">
        {#if !order_placed}
          <span>Complete your order</span>
        {/if}
        <button on:click={closeModal} class="close" />
      </div>

      {#if !order_placed}
        <div class="order-confirmation__step">
          Step {modalInnerSwitchPosition ? '1' : '2'}/2
        </div>
      {/if}

      <div class="order-confirmation__body">
        {#if modalInnerSwitchPosition}
          <span class="order-confirmation__details-text">Please enter your details below</span>
          <form
            on:submit={addCustomerDetails}
            id="address-form"
            class="order-confirmation__form"
            required
          >
            <input
              type="email"
              name="email"
              autocomplete="off"
              class="fullwidth required"
              placeholder="Email address*"
              required
              value={userDetails ? userDetails.email : ''}
            />
            <input
              type="text"
              name="name"
              autocomplete="off"
              class="fullwidth"
              placeholder="Name*"
              required
              value={userDetails ? userDetails.name : ''}
            />
            <input
              type="text"
              name="address_one"
              autocomplete="off"
              class="fullwidth"
              placeholder="Address 1*"
              required
              value={userDetails ? userDetails.address_one : ''}
            />
            <input
              type="text"
              name="address_two"
              autocomplete="off"
              class="fullwidth"
              placeholder="Address 2"
              value={userDetails ? userDetails.address_two : ''}
            />
            <input
              type="text"
              name="city"
              autocomplete="off"
              class="fullwidth"
              placeholder="City*"
              required
              value={userDetails ? userDetails.city : ''}
            />
            <input
              type="text"
              name="post_code"
              autocomplete="off"
              class="fullwidth"
              placeholder="Post code*"
              required
              value={userDetails ? userDetails.post_code : ''}
            />
            <input
              type="text"
              name="phone"
              autocomplete="off"
              class="fullwidth"
              placeholder="Phone number*"
              required
              value={userDetails ? userDetails.phone : ''}
            />
            <span class="order-confirmation__required-text">* Required fileds</span>
            <button
              type="submit"
              class="order-confirmation__submit order-confirmation__details-submit">Next</button
            >
          </form>
        {:else}
          {#if !order_placed}
            <!-- <p>Our delivery team will take payment upon delivery.</p>
            <p>Card only, please!</p> -->

            <p style="color: #DA5234; font-weight: bold; text-transform: uppercase;">
              ONLINE ORDERS FOR COLLECTION ONLY
            </p>
            <!-- <p>We will text you when your order is ready.</p> -->
            <p>Please pay upon collection.</p>
            <p>Cards only!</p>
            <p>Click PLACE ORDER below.</p>
          {:else}
            <p class="order-confirmation__success-text">We've got your order, see you soon!</p>
          {/if}

          {#if !order_placed}
            <div class="order-confirmation__footer">
              <button
                class="order-confirmation__submit"
                on:click={sendOrderEmail}
                disabled={order_submitting}
              >
                {#if order_submitting}
                  <Spinner size="25" speed="750" color="#ffffff" thickness="2" gap="40" />
                {:else}
                  Place order
                {/if}
              </button>
            </div>
          {/if}
        {/if}
      </div>
    </div>
  </Dialog>

  <div class="title">Your Basket</div>
  <div>
    {#if paymentSuccessfull}
      <div class="payment-success-wrapper">
        <p class="payment-success-text">Payment Successful</p>
      </div>
    {/if}
    {#if basket && Object.keys(basket.orders).length}
      <div key={basket.uuid}>
        {#each Object.values(basket.orders).sort((a, b) => sort_by(a, b, 'start_time')) as order}
          <div>
            <div class="subtitle heading">
              {order.vendor_name}
              -
              {moment(order.start_time).format('dddd DD/MM')}
            </div>
            <hr class="separator no-margin" />
            {#each Object.values(order.items)
              .sort((a, b) => sort_by(a, b, 'unit_price'))
              .reverse() as item}
              <div class="item" transition:slide|local={{ duration: 100 }}>
                <div class="count">{item.count}</div>
                <div class="name">{item.name}</div>
                <div class="amount-col">
                  {#if !basket.placed}
                    <button
                      class="delete"
                      disabled={submitting}
                      on:click={() => removeItem(order.id, item.id, true)}
                    />
                  {/if}
                  <span class="amount">&pound; {item.amount}</span>
                </div>
              </div>
            {/each}
            {#if venue.delivery_fee_active && venue.delivery_fee_amount > 0}
              <div class="item" transition:slide|local={{ duration: 100 }}>
                <div class="count">1</div>
                <div class="name">Delivery fee</div>
                <div class="amount-col">
                  <span class="amount">&pound; {venue.delivery_fee_amount}.00</span>
                </div>
              </div>
            {/if}
            <hr class="separator double no-margin" />
            {#if order.error}
              <div class="error">{order.error}</div>
            {:else}
              <div class="customer-notes">
                <label for="customer-notes" class="customer-notes__label">Customer notes</label>
                <textarea
                  id="customer-notes"
                  class="customer-notes__textarea"
                  rows="3"
                  value={order.customer_notes ? order.customer_notes : ''}
                  data-noteid={order.id}
                  on:change={handleNoteChange}
                />
              </div>
              <div class="total subtitle">
                <h4 class="subtotal">Subtotal</h4>
                <h4 class="amount">
                  &pound; {calculateSubtotal(order.subtotal)}
                </h4>
              </div>
              <div class="pickup">
                <div style="flex: 1">
                  <span class="pickup__title">Delivery details</span>
                  {order.pickup_notes || 'Pickup'}
                </div>
                <div style="flex: 1">
                  {#if basket.placed && order.pickup_time}
                    {moment(order.pickup_time).format('H:mm')}
                    -
                    {moment(order.pickup_time).add(15, 'minutes').format('H:mm')}
                  {:else if order.pickup_times}
                    <select
                      bind:value={order.pickup_time}
                      disabled={submitting}
                      class="pickup-select"
                    >
                      {#each order.pickup_times as pickup_time}
                        <option value={pickup_time}>
                          {moment(pickup_time).format('H:mm')}
                          -
                          {moment(pickup_time).add(15, 'minutes').format('H:mm')}
                        </option>
                      {/each}
                    </select>
                  {:else if order.pickup_time_allowed}
                    <span class="pickup__title">Order time</span>
                    ASAP
                  {:else}
                    <span class="pickup__title">Order time</span>
                    <!-- ASAP - we’ll email you when it’s ready -->
                    ASAP
                  {/if}
                </div>
              </div>
            {/if}
            <button
              class="basket-icon"
              on:click={() => animateScroll.scrollTo({ element: '.basket' })}
            >
              <span class="basket-number" />
              <img src="/shopping-cart.svg" alt="Shipping basket icon" />
            </button>
          </div>
        {/each}

        {#if basket.has_error}
          <div class="error">Clear errors to continue</div>
        {:else}
          <hr class="separator dashed" />
          <div class="total">
            <h4 class="subtotal">Total</h4>
            <h4 class="amount">&pound; {calculateTotal(basket.subtotal)}</h4>
          </div>
          {#if basket.discount_amount && basket.voucher_code}
            <h4 class="discount">
              &pound;
              {basket.discount_amount}
              discount applied
            </h4>
          {/if}
          <div class="payment">
            {#if !basket.placed}
              {#if !localStorage.fd_opts}
                {#if !basket.voucher_code}
                  <form on:submit={addVoucher}>
                    <div class="voucher">
                      <input
                        type="text"
                        disabled={submitting}
                        class:voucherErr
                        on:focus={() => (voucherErr = false)}
                        bind:value={voucherCode}
                        placeholder={voucherPlaceholder}
                      />
                      <Button
                        variant="unelevated"
                        type="submit"
                        disabled={!voucherCode || submitting}
                      >
                        <Label>add</Label>
                      </Button>
                    </div>
                  </form>
                {/if}
              {/if}

              <div>
                <!-- {#if locationComplete}
                  <Pay compact={true} amount={calculateTotal(basket.subtotal)} on:authorised={onAuthorised} bind:submitting />
                  
                {:else}
                  <Button on:click={() => locationBox.open(true)} variant="unelevated" disabled={submitting} class="sign-in-button">
                    <Label>Setup Location</Label>
                  </Button>
                {/if} -->
              </div>
              {#if payment_error}
                <div class="error">{payment_error}</div>
              {/if}
            {/if}
          </div>
        {/if}
      </div>
      <div>
        <button class="order-button" on:click={openOrderModal}>order now</button>
      </div>
    {:else}
      <div class="empty"><span>Your basket is empty</span></div>
    {/if}

    <!-- <div class="sign-in">
      {#if $user.loggedIn}
        <Button on:click={() => auth.signOut()} variant="outlined" disabled={submitting} class="sign-in-button white-bg">
          <Label>Sign Out</Label>
        </Button>
        <span style="margin-top: 5px;">Signed in as</span>
        <span>{$user.email}</span>
      {:else}
        <Button on:click={() => signinBox.open(true)} variant="unelevated" disabled={submitting} class="sign-in-button">
          <Label>Sign in</Label>
        </Button>
      {/if}
    </div> -->
  </div>
</div>

<!-- <SigninBox bind:this={signinBox} {venueId} /> -->

<!-- <CustomerLocationBox bind:this={locationBox} {venue} bind:complete={locationComplete} /> -->
<style>
  .close {
    width: 25px;
    height: 25px;
    background: url('/close.svg') center/contain no-repeat;
    border: 0px;
    cursor: pointer;
    margin-left: auto;
    margin: 0 0 0 auto !important;
  }

  .order-confirmation {
    min-width: 500px;
  }
  @media screen and (max-width: 500px) {
    .order-confirmation {
      min-width: auto !important;
    }

    .order-confirmation__header span {
      font-size: 16px;
    }
    .close {
      width: 18px;
      height: 18px;
    }

    .order-confirmation input {
      width: auto !important;
    }
  }
  .order-confirmation__header {
    padding: 20px 20px;
    border: 0;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: Manrope !important;
  }

  .order-confirmation__step {
    padding: 10px 20px;
    background: #ededed;
    font-weight: bold;
    font-family: Manrope !important;
  }

  .order-confirmation__header span {
    color: #3d3b3b;
    text-transform: uppercase;
    font-weight: bold !important;
    font-size: 18px;
    font-family: Manrope !important;
  }
  .order-confirmation__body {
    padding: 20px;
  }

  .order-confirmation__details-text {
    display: inline-block;
    margin: 10px 0;
  }
  .order-confirmation__required-text {
    display: inline-block;
    margin: 10px 0;
    color: #b72b2b;
  }

  .order-confirmation__body input {
    margin-bottom: 8px;
  }

  .order-confirmation__body p {
    color: #000000;
    font-size: 16px;
    font-family: Manrope !important;
    margin: 0 0 12px 0;
  }

  .order-confirmation__footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }

  .order-confirmation__form {
    display: flex;
    flex-direction: column;
  }

  .order-confirmation__submit {
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 1px;
    font-size: 16px;
    border: 0;
    padding: 10px 15px;
    border-radius: 0;
    margin: 0 !important;
    cursor: pointer;
  }
  .order-confirmation__submit {
    background: #3d3b3b;
    color: #ffffff;
  }

  .order-confirmation__details-submit {
    align-self: flex-end;
  }
  .order-button {
    width: 100%;
    padding: 12px;
    border: 0;
    background: #3d3b3b;
    color: #ffffff;
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 1px;
    font-size: 16px;
  }
  .order-confirmation__success-text {
    text-align: center !important;
    font-size: 22px !important;
    margin: 0 0 42px 0 !important;
  }
  .basket {
    margin-top: 30px;
    background: #dcdcdf;
    width: 40%;
    align-self: flex-start;
  }

  @media screen and (max-width: 768px) {
    .basket {
      width: 100%;
    }
  }
  .basket > div {
    padding: 11px;
  }

  .title {
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 32px;
    display: flex;
    align-items: center;
    text-align: center;
    background: #3d3b3b;
    color: white;
  }

  .subtitle {
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
  }

  .heading {
    margin-bottom: 10px;
    margin-top: 17px;
  }

  .empty {
    display: flex;
    font-size: 16px;
    line-height: 32px;
    justify-content: center;
    justify-items: center;
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
  }

  .separator {
    margin-top: 28px;
  }

  .separator.no-margin {
    margin-top: 0px;
  }

  .item {
    display: flex;
    /* justify-content: space-between; */
    font-family: Helvetica;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 18px;
    margin-top: 15px;
    margin-right: 2px;
    margin-bottom: 28px;
    font-family: Helvetica;
  }

  .item .count {
    margin-right: 11px;
  }
  .item .name {
    width: 180px;
    margin-left: 30px;
  }

  .item .amount-col {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    margin-left: auto;
  }

  .amount-col .delete {
    background: url('/delete.svg');
    width: 14px;
    height: 14px;
    border: 0px;
    cursor: pointer;
  }

  .amount {
    font-family: Manrope;
    text-align: end;
  }

  .total {
    display: flex;
    justify-content: space-between;
    justify-items: center;
    /* margin-top: 12px; */
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
  }
  .total .amount {
    min-width: 74px;
  }

  .subtotal {
    flex: 1;
    text-align: end;
    margin-right: 4px;
  }
  .pickup {
    font-family: Helvetica;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 23px;
    display: flex;
    align-items: flex-start;
    display: flex;
    margin-top: 20px;
  }

  .pickup__title {
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    display: block;
    margin-bottom: 10px;
  }

  .pickup > div:first-child {
    margin-right: 15px;
  }

  .pickup select {
    min-width: 100px;
    border: 0;
    margin-left: 15px;
    background-color: white;
  }
  .payment {
    margin-top: 15px;
  }
  .voucher {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  }
  .voucher input[type='text'] {
    padding: 7px;
    font-size: 16px;
    width: 225px;
    height: 30px;
    border: 2px solid #000000;
  }
  .voucherErr::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: red;
    opacity: 1; /* Firefox */
  }

  .voucherErr:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: red;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: red;
  }
  .voucher :global(button.mdc-button) {
    color: white;
    height: 30px;
    min-width: 52px;
    width: fit-content;
    font-weight: bold;
    font-size: 14px;
    padding: 4px 8px;
  }
  .voucher :global(span.mdc-button__label) {
    font-size: 14px;
    line-height: 19px;
  }

  .sign-in {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .error {
    color: red;
    margin: 10px 0;
  }

  .discount {
    margin-top: 0;
    font-size: 14px;
    line-height: 19px;
    text-align: right;
    color: #039c00;
  }

  :global(.sign-in-button) {
    width: 100%;
    margin-top: 25px;
    height: 46px;
    border-radius: 0;
  }

  .basket-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    background: #f0913f;
    border-radius: 50%;
    z-index: 6;
    position: fixed;
    bottom: 2%;
    right: 5%;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    position: fixed;
    border: 0;
  }

  @media screen and (min-width: 768px) {
    .basket-icon {
      display: none;
    }
  }

  .basket-number {
    position: absolute;
    width: 10px;
    height: 10px;
  }

  .customer-notes {
    margin-top: 15px;
  }

  .customer-notes__label {
    margin-bottom: 5px;
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
  }

  .customer-notes__textarea {
    width: 100%;
  }

  .payment-success-wrapper {
    margin-top: 20px;
  }
  .payment-success-text {
    text-transform: uppercase;
    color: #039c00;
    font-size: 24px;
    font-weight: bold;
    margin: 0;
    line-height: 1;
    text-align: center;
  }
</style>
